/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Offline_Last_SyncInputs */



/**
* | output |
* | --- |
* | "Last saved: {time}" |
*
* @param {Offline_Last_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_last_sync = /** @type {((inputs: Offline_Last_SyncInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Last_SyncInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Dernière sauvegarde : ${i?.time}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Última sincronización: ${i?.time}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Última sincronização: ${i?.time}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Ultimo salvataggio: ${i?.time}`)
	return /** @type {LocalizedString} */ (`Last saved: ${i?.time}`)
});